import Communicator from '@/utils/csrbuddy/Communicator';

if (typeof window !== 'undefined') {
  const communicator = new Communicator();
  window.__CSRBuddy__ = communicator;
}